import React from "react";

import moment from "moment-timezone";
import { formatBytes, formatNumber } from "../../../../utils/index";
import ClickableEntry from "./ClickableEntry";

// Takes a date string and returns its description relative to
// the current date.
export const formatDateRelative = (dateStr) => {
  const input = moment.utc(dateStr).fromNow();

  return input;
};

export const getEltAndAccessorBytes = (volume) => {
  const accessor = volume;

  const title = volume === undefined ? "" : `${volume.toLocaleString()} bytes`;

  const element = <div title={title}>{formatBytes(volume, 0)}</div>;

  return {
    accessor,
    element,
  };
};

// Given a date string, returns cell accessor, element, and
// string label (for global table search)
export const getEltAndAccessorDate = (dateStr) => {
  if (dateStr === null || dateStr === undefined || dateStr === "") {
    return {
      accessor: "",
      element: null,
      label: "",
    };
  }

  const accessor = moment.utc(dateStr).startOf("second").valueOf();

  const label = formatDateRelative(dateStr);

  // Format the absolute date in the user's timezone to show onHover
  const title = moment
    .utc(dateStr)
    .tz(moment.tz.guess(true))
    .format("ll LTS z");

  const element = <div title={title}>{label}</div>;

  return {
    accessor,
    label,
    element,
  };
};

export const getEltAndAccessorNumber = (num) => {
  const accessor = num;

  const title = num === undefined ? "" : num.toLocaleString();

  const element = <div title={title}>{formatNumber(num, 0)}</div>;

  return {
    accessor,
    element,
  };
};

export const getEltAndAccessor = ({
  clickable,
  label,
  onClickElt = () => {},
}) => {
  const element = (
    <ClickableEntry
      clickable={clickable}
      label={label}
      onClickElt={onClickElt}
    />
  );

  return {
    accessor: label,
    element,
  };
};

export const getErrorMsgElt = (errorMessages) => {
  const messages = errorMessages
    .filter((msg) => msg)
    .map((msg, index) => <div key={index}>{msg}</div>);

  return messages.length ? messages : null;
};
